import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'

$.fn.isInViewport = function () {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

function initFlatpicker(timeOut = 0) {
	setTimeout(function () {
		const inputs = document.querySelectorAll('.input-date');
		inputs.forEach(input => {
			flatpickr(input, {
				dateFormat: "d-m-Y",
				// altInput: true,
			});
		});
	}, timeOut);
}


const animateCSS = (element, animation, prefix = 'animate__') =>
	// We create a Promise and return it
	new Promise((resolve, reject) => {
		const animationName = `${prefix}${animation}`;
		const elements = document.querySelectorAll(element);

		elements.forEach((element) => {
			element.classList.add(`${prefix}animated`, animationName);

			function handleAnimationEnd(event) {
				event.stopPropagation();
				element.classList.remove(`${prefix}animated`, animationName);
				resolve('Animation ended');
			}

			element.addEventListener('animationend', handleAnimationEnd, { once: true });
		});
	});

$(document).ready(function () {

	initFlatpicker();

	$(document).on('click', '.product-image-trigger', function (e) {
		e.preventDefault();
		const $productImage = $('.product-image').first();
		if ($productImage.length) {
			$productImage[0].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
		} else {
			console.warn('No element with class .product-image found.');
		}
	});

	$(document).on('click', '.alert-user-not-logged-in', function () {
		var text = $(this).data('text');
		Swal.fire({
			text: text
		});
	});

	$('.select2').select2();
	$('.product-search-select').select2();
	$('.product-search-select').on('select2:open', function () {
		$('.select2-dropdown').addClass('product-search-select');
	});

	$('.date-picker').datepicker({
		autoclose: true
	});

	if ($(".section-scroll").length) {
		const ps = new PerfectScrollbar('.section-scroll', {
			wheelSpeed: 2,
			wheelPropagation: true,
			minScrollbarLength: 33,
			suppressScrollX: true,
		});
	}

	var header = document.querySelector("#navbar-header");

	window.addEventListener("scroll", function () {
		if (window.scrollY > 150) {
			header.classList.add("active");
		} else {
			header.classList.remove("active");
		}
	});
	if ($("#title-split").length) {
		// Get the text content
		var text = document.getElementById("title-split").textContent;

		// Split the text into an array of words
		var words = text.split(' ');

		// Create a new HTML content with each word wrapped in a <span> element
		var newContent = words.map(function (word) {
			return '<span>' + word + '</span>';
		}).join('');

		// Set the new content back to the element
		document.getElementById("title-split").innerHTML = newContent;
	}


	// Set up the Intersection Observer
	var observer = new IntersectionObserver(handleIntersection, { threshold: 0.5 });

	// Target elements
	var targetElements = document.querySelectorAll('.divider');


	// Function to be called when a target element comes into view
	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				// Call your function here
				animateCSS('.divider-left', 'fadeInLeft');
				animateCSS('.divider-right', 'fadeInRight');
				animateCSS('.divider-image', 'zoomIn');
				animateCSS('.divider-side', 'zoomIn');
			}
		});
	}

	// Start observing each target element
	targetElements.forEach(element => {
		observer.observe(element);
	});

	// Toggle the height on button click
	$('.toggle-text').click(function () {
		var containerId = $(this).data('target');
		var container = $('#' + containerId);
		container.toggleClass('active');
		// var fullHeight = container.css('max-height', 'auto').height();
		// container.css('max-height', container.css('max-height') === '100px' ? fullHeight + 'px' : '100px');
		// Toggle button text
		var defaultText = $(this).data('default-text');
		var clickedText = $(this).data('clicked-text');

		$(this).text($(this).text() === defaultText ? clickedText : defaultText);
	});

	// Toggle show password
	$('.toggle-password').click(function () {
		var passwordInput = $(this).siblings();
		var fieldType = passwordInput.attr('type');

		if (fieldType === 'password') {
			passwordInput.attr('type', 'text');
		} else {
			passwordInput.attr('type', 'password');
		}
		$(this).toggleClass('active');
	});

	//dark mode
	// const darkModeToggleBtn = $('.toggle-pallete-btn');
	// if (localStorage.getItem(site_key) === 'true') {
	//     $('body').addClass('dark-mode');
	//     darkModeToggleBtn.addClass('active').text('White');
	// } else {
	//     darkModeToggleBtn.text('Black');
	// }

	// darkModeToggleBtn.on('click', function () {
	//     $('body').toggleClass('dark-mode');
	//     $(this).toggleClass('active');

	//     const isDark = $('body').hasClass('dark-mode');
	//     localStorage.setItem(site_key, isDark);

	//     $(this).text(isDark ? 'White' : 'Black');
	// });
	//dark mode

	// TOGGLE SHARE

	$('.section-toggle--btn').click(function () {
		const element = $(this).siblings('.section-toggle--element');
		element.toggleClass('active');
	});

	// TOGGLE SHARE

	// const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	// const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

	// Initialize all tooltips
	// Select the hotspot button

	// Initialize tooltip
	// new bootstrap.Tooltip(hotspotButton);
	const hotspotButtons = document.querySelectorAll('.hotspot');
	const tooltipList = [...hotspotButtons].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

	// Initialize all collapse elements (Bootstrap does this automatically, but you may add this if necessary)

});


//////////scroll la formular cand apesi pe button de cere oferta fix bottom de pe mobil ///

$(document).ready(function () {
	var $button = $('.btn-request-offer');
	var $target = $('.card.template-contact');

	// Scroll lin la click
	$button.on('click', function (e) {
		e.preventDefault();
		$('html, body').animate({
			scrollTop: $target.offset().top
		}, 800); // durata in ms
	});

	// Funcție pentru a verifica dacă secțiunea e în viewport
	function isInViewport(element) {
		if (!element || element.length === 0) return false;
		var elementTop = element.offset().top;
		var elementBottom = elementTop + element.outerHeight();
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
		return elementBottom > viewportTop && elementTop < viewportBottom;
	}

	// Verificăm la scroll dacă e vizibilă secțiunea
	$(window).on('scroll resize', function () {
		if (isInViewport($target)) {
			$button.fadeOut(200);
		} else {
			$button.fadeIn(200);
		}
	});
});

//////////end scroll la formular cand apesi pe button de cere oferta fix bottom de pe mobil ///


// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js